async function wait(durationMs) {
  return new Promise(resolve => {
    setTimeout(resolve, durationMs);
  });
}
export default wait;